/**
 * The Nexus rail as data: which destinations it draws, in which app each lives, and what selecting
 * one does from the app on screen. Kept apart from the frame's React so the decision can be proven
 * without rendering (`rail.spec.ts`).
 */
/**
 * The design's rail, top to bottom. Customers, Connect and Settings are portal screens still to be
 * built (Connect is NEX2-229, Settings NEX2-230); each turns `ready` when its screen lands.
 */
const MAIN = [
    { app: "portal", key: "home", label: "Home", path: "/", ready: true },
    { app: "portal", key: "customers", label: "Customers", path: "/customers", ready: false },
    { app: "portal", key: "connect", label: "Connect", path: "/connect", ready: false },
    { app: "checkout", key: "checkout", label: "Checkout", path: "/", ready: true },
];
const FOOTER = [
    { app: "portal", key: "settings", label: "Settings", path: "/settings", ready: false },
];
const stateOf = (destination, { active, app, links }) => {
    if (!destination.ready) {
        return { kind: "unavailable", reason: "coming-soon" };
    }
    if (destination.app === app) {
        // The item on screen keeps its route: selecting it returns to the destination's start, as
        // Checkout's item has always returned to Drafts (PR #87 review).
        return destination.key === active
            ? { kind: "active", path: destination.path }
            : { kind: "route", path: destination.path };
    }
    // A runtime-document origin is canonical - no path, no trailing slash - so the path appends.
    const origin = links[destination.app];
    return origin === undefined
        ? { kind: "unavailable", reason: "not-linked" }
        : { href: `${origin}${destination.path}`, kind: "url" };
};
export const railItems = (input) => {
    const item = (destination) => ({
        key: destination.key,
        label: destination.label,
        state: stateOf(destination, input),
    });
    return { footer: FOOTER.map(item), main: MAIN.map(item) };
};
//# sourceMappingURL=rail.js.map